import React from 'react';
import { Observe } from 'rewire-core';
import { WithStyle } from 'rewire-ui';
import merge from 'deepmerge';
import { MuiThemeProvider, Theme } from '@material-ui/core/styles';
import Tab from '@material-ui/core/Tab';
import Tabs from '@material-ui/core/Tabs';
import navigationTabsModel from './NavigationTabsModel';
import { withStyles } from '../utility/styles';
import mainPageModel from './MainPageModel';
import { Link } from '../utility/Link';

const theme = (outerTheme: Theme) => ({
  ...outerTheme,
  overrides: merge(outerTheme.overrides || {}, {
    MuiTabs: {
      root: {
        minHeight: '46px',
        overflow: 'visible',
        [outerTheme.breakpoints.down('md')]: {
          position: 'static',
          left: 'unset',
        },
      },
    },
    MuiTab: {
      root: {
        borderRadius: 0,
        height: '46px',
        fontSize: '0.8125em',
        minHeight: '46px',
        [outerTheme.breakpoints.up('sm')]: {
          minWidth: '100px',
        },
        color: outerTheme.palette.navBarSecondary.main,
        fontWeight: '400',
      },
      textColorInherit: {
        transition: '.3s ease-out',
        opacity: '1',
        color: outerTheme.palette.navBarSecondary.main,
        '&:hover': {
          opacity: '1',
          background: 'none',
          backgroundColor: outerTheme.palette.dialogPrimary.dark,
          color: outerTheme.palette.navBarPrimary.main,
        },
        '&$disabled': {
          pointerEvents: 'auto !important',
          backgroundColor: 'transparent',
          color: `${outerTheme.palette.navBarSecondary.main}`,
          '&:hover': {
            opacity: '0.5',
            backgroundColor: 'transparent',
            color: `${outerTheme.palette.navBarSecondary.main}`,
          },
          '&:active': {
            pointerEvents: 'none !important',
          },
        },
      },
    },
  }),
});

const styles = (theme: Theme) => ({
  tabNavIndicator: {
    backgroundColor: 'transparent',
  },
  tabSelected: {
    backgroundColor: `${theme.palette.dialogPrimary.main} !important`,
    color: `${theme.palette.navBarPrimary.main} !important`,
    fontWeight: 500,
  },
});

interface IPrimaryNavigationTabsProps {}

interface IPrimaryNavigationTabsState {}

type PrimaryNavigationTabsProps = WithStyle<ReturnType<typeof styles>, IPrimaryNavigationTabsProps>;

class PrimaryNavigationTabs extends React.Component<PrimaryNavigationTabsProps, IPrimaryNavigationTabsState> {
  render() {
    const { classes } = this.props;

    return (
      <Observe
        render={() => {
          const planRoute = navigationTabsModel.getPrimaryPlanRoute();
          const payRoute = navigationTabsModel.getPrimaryPayRoute();
          const batchRoute = navigationTabsModel.getPrimaryBatchRoute();
          const reportRoute = navigationTabsModel.getPrimaryReportRoute();
          const testRoute = navigationTabsModel.getTestRoute();

          return (
            <MuiThemeProvider theme={theme}>
              <Tabs value={navigationTabsModel.primaryIdx} classes={{ indicator: classes.tabNavIndicator }}>
                <Tab label="Plan" classes={{ selected: classes.tabSelected }} component={Link} to={planRoute} />
                <Tab label="Pay" classes={{ selected: classes.tabSelected }} component={Link} to={payRoute} />
                <Tab
                  label="Batch"
                  classes={{ selected: classes.tabSelected }}
                  component={Link}
                  to={batchRoute}
                  disabled={mainPageModel.testModeEnabled}
                  title={mainPageModel.testModeEnabled ? 'Batch not available - Test mode enabled' : ''}
                />
                <Tab label="Report" classes={{ selected: classes.tabSelected }} component={Link} to={reportRoute} />
                {mainPageModel.testModeEnabled ? (
                  <Tab label="Test" classes={{ selected: classes.tabSelected }} component={Link} to={testRoute} />
                ) : null}
              </Tabs>
            </MuiThemeProvider>
          );
        }}
      />
    );
  }
}

export default withStyles<IPrimaryNavigationTabsProps>(styles, PrimaryNavigationTabs);
